"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allBuildings = exports.copperOreStorageConfig = exports.ironOreStorageConfig = exports.goldStorageConfig = exports.copperStorageConfig = exports.ironStorageConfig = exports.stoneStorageConfig = exports.goldFurnaceConfig = exports.goldProviderConfig = exports.copperFurnaceConfig = exports.copperProviderConfig = exports.ironFurnaceConfig = exports.ironProviderConfig = exports.geoExtractorConfig = exports.batteryConfig = exports.solarPanelConfig = void 0;
// Re-export individual building configs
var solarpane_1 = require("./buildings/solarpane");
Object.defineProperty(exports, "solarPanelConfig", { enumerable: true, get: function () { return solarpane_1.solarPanelConfig; } });
var battery_1 = require("./buildings/battery");
Object.defineProperty(exports, "batteryConfig", { enumerable: true, get: function () { return battery_1.batteryConfig; } });
var geoextractor_1 = require("./buildings/geoextractor");
Object.defineProperty(exports, "geoExtractorConfig", { enumerable: true, get: function () { return geoextractor_1.geoExtractorConfig; } });
var ironprovider_1 = require("./buildings/ironprovider");
Object.defineProperty(exports, "ironProviderConfig", { enumerable: true, get: function () { return ironprovider_1.ironProviderConfig; } });
var ironfurnace_1 = require("./buildings/ironfurnace");
Object.defineProperty(exports, "ironFurnaceConfig", { enumerable: true, get: function () { return ironfurnace_1.ironFurnaceConfig; } });
var copperprovider_1 = require("./buildings/copperprovider");
Object.defineProperty(exports, "copperProviderConfig", { enumerable: true, get: function () { return copperprovider_1.copperProviderConfig; } });
var copperfurnace_1 = require("./buildings/copperfurnace");
Object.defineProperty(exports, "copperFurnaceConfig", { enumerable: true, get: function () { return copperfurnace_1.copperFurnaceConfig; } });
var goldprovider_1 = require("./buildings/goldprovider");
Object.defineProperty(exports, "goldProviderConfig", { enumerable: true, get: function () { return goldprovider_1.goldProviderConfig; } });
var goldfurnace_1 = require("./buildings/goldfurnace");
Object.defineProperty(exports, "goldFurnaceConfig", { enumerable: true, get: function () { return goldfurnace_1.goldFurnaceConfig; } });
var stonestorage_1 = require("./buildings/stonestorage");
Object.defineProperty(exports, "stoneStorageConfig", { enumerable: true, get: function () { return stonestorage_1.stoneStorageConfig; } });
var ironstorage_1 = require("./buildings/ironstorage");
Object.defineProperty(exports, "ironStorageConfig", { enumerable: true, get: function () { return ironstorage_1.ironStorageConfig; } });
var copperstorage_1 = require("./buildings/copperstorage");
Object.defineProperty(exports, "copperStorageConfig", { enumerable: true, get: function () { return copperstorage_1.copperStorageConfig; } });
var goldstorage_1 = require("./buildings/goldstorage");
Object.defineProperty(exports, "goldStorageConfig", { enumerable: true, get: function () { return goldstorage_1.goldStorageConfig; } });
var ironorestorage_1 = require("./buildings/ironorestorage");
Object.defineProperty(exports, "ironOreStorageConfig", { enumerable: true, get: function () { return ironorestorage_1.ironOreStorageConfig; } });
var copperorestorage_1 = require("./buildings/copperorestorage");
Object.defineProperty(exports, "copperOreStorageConfig", { enumerable: true, get: function () { return copperorestorage_1.copperOreStorageConfig; } });
const solarpane_2 = require("./buildings/solarpane");
const battery_2 = require("./buildings/battery");
const geoextractor_2 = require("./buildings/geoextractor");
const ironprovider_2 = require("./buildings/ironprovider");
const ironfurnace_2 = require("./buildings/ironfurnace");
const copperprovider_2 = require("./buildings/copperprovider");
const copperfurnace_2 = require("./buildings/copperfurnace");
const goldprovider_2 = require("./buildings/goldprovider");
const goldfurnace_2 = require("./buildings/goldfurnace");
const stonestorage_2 = require("./buildings/stonestorage");
const ironstorage_2 = require("./buildings/ironstorage");
const copperstorage_2 = require("./buildings/copperstorage");
const goldstorage_2 = require("./buildings/goldstorage");
const ironorestorage_2 = require("./buildings/ironorestorage");
const copperorestorage_2 = require("./buildings/copperorestorage");
exports.allBuildings = {
    'solarpane': solarpane_2.solarPanelConfig,
    'battery': battery_2.batteryConfig,
    'geoextractor': geoextractor_2.geoExtractorConfig,
    'mining-iron': ironprovider_2.ironProviderConfig,
    'iron-furnace': ironfurnace_2.ironFurnaceConfig,
    'mining-copper': copperprovider_2.copperProviderConfig,
    'copper-furnace': copperfurnace_2.copperFurnaceConfig,
    'mining-gold': goldprovider_2.goldProviderConfig,
    'gold-furnace': goldfurnace_2.goldFurnaceConfig,
    'storage-stone': stonestorage_2.stoneStorageConfig,
    'storage-iron': ironstorage_2.ironStorageConfig,
    'storage-copper': copperstorage_2.copperStorageConfig,
    'storage-gold': goldstorage_2.goldStorageConfig,
    'storage-iron-ore': ironorestorage_2.ironOreStorageConfig,
    'storage-copper-ore': copperorestorage_2.copperOreStorageConfig,
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings.js
// module id = 46gQ
// module chunks = 0